import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { MdHorizontalRule } from "react-icons/md";
import { twMerge } from "tailwind-merge";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { buttonStyleHiddenOnMobile } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonDividerProps {
  className?: string;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonDivider = ({ className, children }: TextEditorMenuButtonDividerProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  return (
    <Tooltip content={t("buttons.horizontalrule")}>
      <button
        type="button"
        onClick={() => {
          if (editor) {
            editor.chain().focus().setHorizontalRule().run();
          }
        }}
        className={twMerge(buttonStyleHiddenOnMobile, className)}
        disabled={disabled}
      >
        {children ?? <MdHorizontalRule className="h-6 w-6" />}
      </button>
    </Tooltip>
  );
};
